export const KEYS = {
  token: 'app-token',
  menu: 'app-menu',
  menuMode: 'app-menu-mode'
}

const localStorageSchema = {
  localStorage: {
    getItem: () => {},
    setItem: () => {},
    removeItem: () => {},
    clear: () => {}
  }
}

const { localStorage } =
  typeof window !== 'undefined' ? window : localStorageSchema

export const localStorageService = {
  get: (key: string) => localStorage.getItem(key),
  set: (key: string, value: string) => localStorage.setItem(key, value),
  remove: (key: string)=> localStorage.removeItem(key),
  clear: () => localStorage.clear()
}

export default localStorageService
